import styled from "styled-components";
import { devices } from "../../utils/styled/_variables.styled";

export const ButtonContainerBox = styled.div`
  padding: 48px 24px;
  @media (min-width: 1220px) {
    padding: 48px 40px;
  }
  &.buttoncontainer__impar {
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    flex-direction: column;
    align-content: center;

    @media (min-width: 1220px) {
      flex-direction: row;
      flex-flow: nowrap;
      width: 100%;
      max-width: 898px;
      justify-self: center;
    }
  }

  &.buttoncontainer__par {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    flex-direction: column;
    margin: 0 auto;
    max-width: 898px;

    @media (min-width: 1220px) {
      flex-direction: row;
      width: 100%;
      max-width: 898px;
    }

    @media ${devices.mobileSmall} {
      width: 100%;
    }
  }

  .buttoncontainer__box_par {
    display: grid;

    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr;

    @media ${devices.mobileSmall} {
      grid-template-rows: 1fr 1fr;
      grid-template-columns: 1fr;
    }
    @media (min-width: 1220px) {
      width: 100%;
    }

    gap: 16px;

    .buttoncard {
      width: 100%;
      height: 160px;
      min-width: 163px;
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 16px;
      border: 1px solid rgba(74, 85, 104, 0.1);
      box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.06);
      border-radius: 8px;
      text-decoration: none;
      @media (min-width: 1220px) {
        gap: 8px;
        height: 176px;
        padding: 24px;
        padding: 24px;
      }
      @media ${devices.mobile} {
        flex-direction: row;
        height: 101px;
        padding: 28px 16px;
        align-items: center;
      }
    }
  }

  .buttoncontainer__box_impar {
    max-width: 550px;
    width: 100%;

    gap: 16px;

    @media ${devices.mobile} {
      max-width: 100%;
    }

    .buttoncard {
      width: 100%;
      height: 100px;
      min-width: 163px;
      display: flex;
      flex-direction: row;
      gap: 20px;
      padding: 24px;
      border: 1px solid rgba(74, 85, 104, 0.1);
      box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.06);
      border-radius: 8px;
      text-decoration: none;
      align-items: center;
      
      
      @media (min-width: 1220px) {
        flex-direction: column;
        align-items: normal;
        gap: 8px;
        padding: 20px;
        height: 211px;

        .buttoncard__text{
          height: 107px;
        }

        .buttoncard__text{
          height: 107px;
        }
      }
    }
  }
`;
